import React, {useState} from 'react';
import Button from "components/Button";
import Tr from "translations/Translations";
import {Typography, withStyles} from "@material-ui/core";
import DownloadIcon from '@material-ui/icons/GetApp';
import UploadImportFile from "./components/UploadImportFile";
import {downloadImportTemplate} from "./lib/downloadImportTemplate";
import ImporterForm from "./components/ImporterForm";
import GridBlock from "components/GridBlock";

export const style = theme => {
    return {
        root: {
            marginTop: theme.spacing(2)
        },
        button: {
            width: 400,
            height: 60,
            marginBottom: theme.spacing(6),
        },
        text: {
            marginBottom: theme.spacing(1),
        }
    }
}


const ImportScreen = (
    {
        classes,
        id
    }
) => {

    const hideDownloadingTemplate = () => {
        setDownloadingInProgress(false);
    }
    const downloadImportTemplateClick = async () => {
        setDownloadingInProgress(true);
        await downloadImportTemplate(id, hideDownloadingTemplate, hideDownloadingTemplate);
    }
    const [downloadingInProgress, setDownloadingInProgress] = useState(false);


    return (
        <>
            <GridBlock
                direction="column"
            >
                <Typography
                    className={classes.text}
                >
                    {Tr('dealings_import_step_one_download')}
                </Typography>

                <Button
                    color={'secondary'}
                    className={classes.button}
                    onClick={downloadImportTemplateClick}
                    Icon={DownloadIcon}
                >
                    {Tr('dealings_import_form')}
                </Button>

                <Typography
                    className={classes.text}
                >
                    {Tr('dealings_import_step_two_upload')}
                </Typography>
                <UploadImportFile id={id}/>
            </GridBlock>
            <ImporterForm downloadingInProgress={downloadingInProgress}/>
        </>
    );
};

export default withStyles(style)(ImportScreen)